// import this after install `@mdi/font` package
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import { uk, en } from 'vuetify/locale'
import Signal from "~/components/icons/signal.vue";

export default defineNuxtPlugin((app) => {

    const vuetify = createVuetify({
        // Пороги v3 закріплені явно. Vuetify 4 перерахував їх під MD3 (md 840, lg 1145,
        // xl 1545, xxl 2138), і це мовчки зсунуло б респонсив у всіх 57 файлах із cols/sm/md/lg,
        // у mobile-breakpoint="md" бічної панелі та меню, і в кожному useDisplay. Найбільше
        // б постраждав /uav-flight: його межа списку й мапи навмисне стоїть на lg, щоб планшет
        // у ландшафті (1180–1194px) лишався у «вузькій» гілці — на 1145 він би туди вже не влазив.
        // Переїзд на MD3-пороги — окрема задача дизайну, не побічний ефект апгрейду.
        display: {
            thresholds: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
                xxl: 2560,
            },
        },
        theme: {
            defaultTheme: parseInt(localStorage.getItem('blackTheme') || '0') ? 'dark' : 'light',

            themes: {
                light: {
                    colors: {
                        primary: '#00897B', // teal-darken-1
                        error: '#B71C1C', // red-darken-4
                        "app-bar": '#37474F',
                        "app-loader": "#546E7A",
                        shaded: "#757575",
                        background: '#F5F5F5',
                        "panels-with-cards": '#EEEEEE',
                        "chat-message-received": "#ffffff",
                        "chat-message-sent": "#e3f2fd",
                        "frequency-range-selector": "#e9f4f4",
                        // Маркер непрочитаних повідомлень у треді заявки — той самий «непрочитане»,
                        // що й червоний badge у ChatsButton, але окремою змінною: чіп, його пульсація
                        // і рамка картки мають мінятись разом.
                        "unread-note": "#dc4e50",
                    },
                },
                dark: {
                    colors: {
                        primary: '#26A69A', // teal-lighten-2
                        error: '#E57373', // red-lighten-2
                        "app-bar": '#212B30',
                        "app-loader": "#455A64",
                        shaded: "#BDBDBD",
                        "panels-with-cards": '#424242',
                        "chat-message-received": "#353d3e",
                        "chat-message-sent": "#2b5a64",
                        "frequency-range-selector": "#283332",
                        "unread-note": "#dc4e50",
                    }
                }
            }
        },
        locale: {
            locale: 'uk',
            fallback: 'en',
            messages: { uk, en },
        },
        icons: {
            aliases: {
                signal: Signal,
            },
        },
    });
    app.vueApp.use(vuetify);
});